import { Box, Chip } from '@mui/material';
import {
  N11OrderStatus,
  n11OrderStatusDescriptionMap,
  n11OrderStatusNameMap,
} from '../../../interfaces/N11/N11OrderStatus';

interface N11StatusCellProps {
  status: N11OrderStatus;
}

export const N11StatusCell = (props: N11StatusCellProps) => {
  const getColor = () => {
    switch (props.status) {
      case N11OrderStatus.CREATED:
        return 'success';
      default:
        return 'error';
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Chip
        size='small'
        variant='filled'
        color={getColor()}
        label={n11OrderStatusNameMap[props.status]}
      />

      <Chip
        size='small'
        variant='filled'
        color={getColor()}
        label={n11OrderStatusDescriptionMap[props.status]}
      />
    </Box>
  );
};
